import React from "react";
import { useNavigate } from "react-router-dom";
import "../App.css";

function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="page-container">
      <div
        className="card"
        style={{ maxWidth: "600px", margin: "0 auto", textAlign: "center" }}
      >
        <div style={{ fontSize: "6rem", marginBottom: "1rem" }}>404</div>
        <h1 className="card-title" style={{ marginBottom: "1rem" }}>
          Page non trouvée
        </h1>
        <p
          className="text-muted"
          style={{ marginBottom: "2rem", fontSize: "1.1rem" }}
        >
          Désolé, la page que vous recherchez n'existe pas.
        </p>
        <button
          className="button"
          onClick={() => navigate("/")}
          style={{ padding: "1rem 2rem", fontSize: "1rem" }}
        >
          Retour à l'accueil
        </button>
      </div>
    </div>
  );
}

export default NotFound;
